import * as React from "react";
import TextsmsIcon from "@material-ui/icons/Textsms";
import {
  Stack,
  Columns,
  Column,
  Heading,
  Button,
  Text,
} from "@origin-digital/ods-core";

export const AppleBusinessChat = () => {
  return (
    <Stack data-id="apple-business-chat" space="medium" alignX="left">
      <Columns space="small">
        <Column width="content">
          <TextsmsIcon color="secondary" />
        </Column>
        <Column width="flex">
          <Heading variant="h4">Text us, 24/7</Heading>
        </Column>
      </Columns>
      <Stack space="small">
        <Text>
          iPhone SMS service is now available. Message us! We'll make sure your
          questions get answered and your problems are solved.
        </Text>
      </Stack>
      <Button
        data-id="help-support:apple-business-chat"
        href="https://bcrw.apple.com/urn:biz:141fae00-d0b6-4fba-9c7c-6e6a6cfaab63"
        variant="outlined"
      >
        Send a text
      </Button>
    </Stack>
  );
};
